import { CustomFormField } from './custom-form-field';

export class CustomFormAnswer {
  public field: CustomFormField;
  public value: string;
}
